module.exports = __webpack_public_path__ + "img/Close.d85097e4.svg";